import React, { useEffect, useRef, useLayoutEffect, useState } from "react";
import Tooltip from "antd/lib/tooltip";

const PillContainer = ({ pills }) => {
  const divRefParent = useRef(null);
  const divRefInner = useRef(null);
  const pillsRefs = useRef([]);
  let arr = [];
  for (let i = 0; i < pills?.length; i++) {
    arr?.push(i);
  }
  const [visiblePills, setVisiblePills] = useState(arr);
  const [hiddenPills, setHiddenPills] = useState([]);

  const calculateWidth = () => {
    if (divRefInner.current) {
      window.requestAnimationFrame(() => {
        const parentWidth = divRefParent.current.offsetWidth;
        const innerWidth = divRefParent.current.offsetWidth - 70;

        let totalWidth = 0;
        let visiblePillsIndices = [];
        let hiddenPillsArray = [];

        pillsRefs.current.forEach((pillRef, index) => {
          if (pillRef) {
            const pillWidth = pillRef.offsetWidth;
            totalWidth += pillWidth;

            if (totalWidth <= innerWidth) {
              visiblePillsIndices.push(index);
            } else {
              hiddenPillsArray.push(pillRef.textContent || `Pill ${index + 1}`);
            }
          }
        });

        setVisiblePills(visiblePillsIndices);
        setHiddenPills(hiddenPillsArray);
      });
    }
  };

  useLayoutEffect(() => {
    calculateWidth();

    const handleResize = () => {
      window.requestAnimationFrame(calculateWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div ref={divRefParent} className="ner-attribute-pill-container">
      <div ref={divRefInner} className="ner-attribute-pill-inner-container">
        {visiblePills.map((index) => (
          <div
            className="ner-attribute-pill"
            key={index}
            ref={(el) => (pillsRefs.current[index] = el)}
          >
            {pills[index]}
          </div>
        ))}
      </div>
      {hiddenPills.length > 0 && (
        <div className="ner-attribute-pill ner-hidden-pill">
          <Tooltip
            color="#3B5175"
            title={
              <>
                <div
                  className="custom_scroll"
                  style={{
                    maxWidth: "27rem",
                    maxHeight: "23rem",
                    overflow: "auto",
                    scrollBehavior: "smooth",
                  }}
                >
                  {hiddenPills?.length > 0 &&
                    hiddenPills?.map((el, index) => {
                      const isLastElement = index === hiddenPills.length - 1;
                      return (
                        <div key={index}>
                          {el}
                          {!isLastElement && ","}
                        </div>
                      );
                    })}
                </div>
              </>
            }
          >
            <span className="text-ellipsis">+{hiddenPills.length}</span>
          </Tooltip>
        </div>
      )}
    </div>
  );
};

export default React.memo(PillContainer);
